import { Component } from '@angular/core';

@Component({
  selector: 'app-race-to-tge',
  standalone: false,
  templateUrl: './race-to-tge.component.html',
  styleUrl: './race-to-tge.component.scss',
})
export class RaceToTgeComponent {}
